import { Label, TooltipHost, Icon, Text } from "@fluentui/react";
import { styles } from "../ExperimentDetailsForm/experimentDetailsForm.styles";

interface BaseLabelRendererProps {
  label: string;
  tooltip?: string;
  isRequired?: boolean;
  description?: string | React.ReactNode;
}

const BaseLabelRenderer: React.FC<BaseLabelRendererProps> = ({
  label,
  isRequired = false,
  tooltip,
  description,
}) => {
  return (
    <>
      <Label
        className={styles.experimentDetailsLabel}
        style={{ marginBottom: description ? "4px" : "8px" }}
      >
        {isRequired && (
          <span className={styles.experimentDetailsLabelAsterisk}>*</span>
        )}
        {label}
        {tooltip && (
          <TooltipHost content={tooltip}>
            <Icon
              iconName="Info"
              className={styles.experimentDetailsTooltip}
              data-testid="info-icon"
            />
          </TooltipHost>
        )}
      </Label>
      {description && (
        <Text variant="small" className={styles.experimentDetailsDescription}>
          {description}
        </Text>
      )}
    </>
  );
};

export default BaseLabelRenderer;
